module.exports = __webpack_public_path__ + "img/del.18894e89.png";